import { render, staticRenderFns } from "./audioPlayer.vue?vue&type=template&id=4ba63d6e&scoped=true"
import script from "./audioPlayer.vue?vue&type=script&lang=js"
export * from "./audioPlayer.vue?vue&type=script&lang=js"
import style0 from "./audioPlayer.vue?vue&type=style&index=0&id=4ba63d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba63d6e",
  null
  
)

export default component.exports